import React from 'react';
import QuickSearchResultItem from './QuickSearchResultItem';
import { translate } from '../Services/translation';

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  const filterByCategory = (category) => {
    const items = result.filter((item) => item.category === category);
    return items;
  };
  return (
    <div className="quick-search-result">
      <div className="row">
        <div className="columns small-12 quick-search-result__seeAllMobile">
          <a href={searchUrl}>
            <button className="button secondary dark">SEE ALL RESULTS</button>
          </a>
        </div>
        <div className="columns small-12 quick-search-result__wrapper">
          <div className="row">
            <QuickSearchResultItem
              title="products"
              items={filterByCategory('Products')}
              lg={2}
              max={6}
            />
            <QuickSearchResultItem
              title="pages"
              items={filterByCategory('Pages')}
            />
            <QuickSearchResultItem
              skipPaddingRight={true}
              title="categories"
              items={filterByCategory('Categories')}
              linkName={true}
            />

            <div className="columns small-12 quick-search-result__seeAll">
              <a href={searchUrl}>
                <button className="button secondary dark quick-search-result__seeAll--button">
                  {translate('quicksearch.seeallresults')}
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickSearchResult;
